export enum DataBuilderDropGridTypes {
	normal = 'normal',
	slim = 'slim',
	empty = 'empty',
}
